import {
  useCustomMutation,
  useInvalidate,
  useNotification,
  useTranslate,
} from '@refinedev/core';
import { Button } from 'antd';
import { CloudSyncOutlined } from '@ant-design/icons';
import type { ElibriAvailabilitySyncRunOut } from '@/api/generated/schemas';
import { extractBackendMessage } from '@/utils/apiError';

const RESOURCE = 'content_catalog.distribution_periods';
const REFRESH_URL = 'content_catalog/distribution_periods/elibri_sync';

export const RefreshFromElibriButton = () => {
  const t = useTranslate();
  const { open: notify } = useNotification();
  const invalidate = useInvalidate();
  const { mutate, mutation } =
    useCustomMutation<ElibriAvailabilitySyncRunOut>();

  const handleClick = () =>
    mutate(
      {
        url: REFRESH_URL,
        method: 'post',
        values: {},
        successNotification: false,
        errorNotification: false,
      },
      {
        onSuccess: ({ data: run }) => {
          notify?.({
            type: 'success',
            message: t('notifications.success'),
            description: t(
              'content_catalog.distribution_periods.refresh.success',
              {
                added: run.items_added,
                updated: run.items_updated,
                removed: run.items_removed,
              }
            ),
          });
          invalidate({ resource: RESOURCE, invalidates: ['list'] });
        },
        onError: (error) => {
          notify?.({
            type: 'error',
            message: t('notifications.error'),
            description:
              extractBackendMessage(error) ??
              t('content_catalog.distribution_periods.refresh.error_fallback'),
          });
        },
      }
    );

  return (
    <Button
      type="primary"
      icon={<CloudSyncOutlined />}
      loading={mutation.isPending}
      onClick={handleClick}
    >
      {t('content_catalog.distribution_periods.refresh.button')}
    </Button>
  );
};
